import React, { useState } from "react";
import QRCodeIcon from "../../../assets/images/qr_code_icon.svg";
import SearchIcon from "../../../assets/images/search.svg";
import QrScannerModal from "../../../components/elements/QrScannerModal";
import "../css/SearchBar.css";

const SearchBar = ({
  onSearch,
  onQrScanSuccess,
  showQrScan = true,
  value,
  placeholder = "Search",
}) => {
  const [isModalOpen, setIsModalOpen] = useState(false);

  const handleOpenModal = () => {
    setIsModalOpen(true);
  };

  const handleCloseModal = () => {
    setIsModalOpen(false);
  };

  const handleScanSuccess = (validQR) => {
    handleCloseModal();
    // Call the callback to handle QR scan success
    onQrScanSuccess(validQR);
    onSearch(validQR);
  };

  const handleClear = () => {
    onSearch("");
  };

  const hasValue = value && value.trim().length > 0;

  return (
    <div className={`trip-request-search-bar${hasValue ? " trip-request-search-bar--has-value" : ""}`}>
      <img
        src={SearchIcon}
        className="trip-request-search-icon"
        alt="search-logo"
      />

      <input
        type="text"
        placeholder={placeholder}
        value={value || ""}
        onChange={(e) => onSearch(e.target.value)}
      />
      {showQrScan && (
        <img
          src={QRCodeIcon}
          className="trip-request-qr-code-icon"
          alt="qr-code-logo"
          onClick={handleOpenModal}
        />
      )}
      {hasValue && (
        <button
          type="button"
          className="trip-request-search-clear"
          onClick={handleClear}
          aria-label="Clear search"
        >
          ×
        </button>
      )}

      <QrScannerModal
        open={isModalOpen}
        handleClose={handleCloseModal}
        onScanSuccess={handleScanSuccess}
      />
    </div>
  );
};

export default SearchBar;
